import { axios } from '@Root/API'

export const changeStatus = (applicationId, formStatusId) => {
	return axios.post('change/form/status', {
		application_id: applicationId,
		forms_status_id: formStatusId,
	})
}
